import React, { useEffect, useState } from "react";
import "./styles.scss";
import { Col, Container, Modal, Row } from "react-bootstrap";
import { FaEye } from "react-icons/fa";
import PageHeader from "../../../../dashboard/components/page-header/PageHeader";
import { useParams } from "react-router-dom";
import { useFirestore, useFunctions } from "reactfire";
import firebase from "firebase";
import moment from "moment";
import { FcFile } from "react-icons/fc";
import { useAppUser } from "../../../../../contexts/user-context/UserContext";
import { ClipLoader } from "react-spinners";
import UserNotification from "../../../../../shared/components/Notification/UserNotification";
import { FileContent } from "../../../../../shared/constants/Constant";

export interface MentoringSession {
  id: string;
  title: string;
  mentorId: string;
  participantIds: string[];
  teamId: string;
  startAt: any;
  endAt: any;
  duration: string;
  description: string;
  fileURLs: FileContent[];
  meetingURL: string;
  active: boolean;
  meetingURLActivated: boolean;
  meetingURLCode: string;
  createdBy: string;
  createdAt: Date;
  updatedAt: Date;
  mentoringSessionRequest?: any;
}
const ViewMentoringSession = () => {
  const { id } = useParams() as any;
  const store = useFirestore();
  const { userRole } = useAppUser();
  const [code, setCode] = useState("");
  const [codeError, setCodeError] = useState("");
  const [state, setState] = useState<MentoringSession>({
    active: false,
    createdAt: new Date(),
    createdBy: "",
    description: "",
    duration: "",
    endAt: new Date(),
    fileURLs: [],
    meetingURLActivated: false,
    meetingURLCode: "",
    id: "",
    meetingURL: "",
    mentorId: "",
    participantIds: [],
    startAt: new Date(),
    teamId: "",
    title: "",
    updatedAt: new Date(),
  });
  const [members, setMembers] = useState<{ id: string; fullName: string }[]>(
    []
  );
  const [mentor, setMentor] = useState<{ id: string; fullName: string }>({
    id: "",
    fullName: "",
  });
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    let unset = undefined;
    if (unset === undefined) {
      unset = store
        .collection("sessions")
        .doc(id)
        .onSnapshot({}, (snapshot) => {
          setState((ps) => {
            return { ...(snapshot.data() as any) };
          });
        });
    }
    return unset;
  }, [store, id]);

  useEffect(() => {
    let unset = undefined;
    if (unset === undefined) {
      if (state.mentorId) {
        unset = store
          .collection("mentors")
          .doc(state.mentorId)
          .onSnapshot({}, (snapshot) => {
            setMentor((ps) => {
              return { ...(snapshot.data() as any) };
            });
          });
      }
    }
    return unset;
  }, [store, state.mentorId]);

  useEffect(() => {
    let unset = undefined;
    if (unset === undefined) {
      setMembers([]);
      if (state && state.teamId !== "") {
        unset = store
          .collection("teams")
          .where(firebase.firestore.FieldPath.documentId(), "==", state.teamId)
          .onSnapshot({}, (snapshot) => {
            snapshot.docChanges().forEach((change) => {
              if (change.type === "added" || change.type === "modified") {
                const teamMembers: any[] = change.doc.data().members;

                if (teamMembers && teamMembers.length > 0) {
                  teamMembers.forEach((member) => {
                    setMembers((ps) => {
                      ps.push({
                        fullName: member.fullName,
                        id: member.id,
                      });
                      return Object.assign([], ps);
                    });
                  });
                }
              }
            });
          });
      }
    }
    return unset;
  }, [store, state, state.teamId]);

  useEffect(() => {
    if (
      state.mentoringSessionRequest &&
      state.mentoringSessionRequest.requestedTeamName === "PUBLIC-TEAM"
    ) {
      store
        .collection("members")
        .doc(state.mentoringSessionRequest.requestedTeamMemberId)
        .get()
        .then((value) => {
          const member = value.data() as any;
          setMembers((ps) => {
            if (ps.filter((m) => m.id === value.id).length <= 0)
              ps.push({
                id: value.id,
                fullName: member.fullName as string,
              });
            return [...ps];
          });
        });
    }
  }, [store, state.mentoringSessionRequest]);

  const activateSessionFunction = useFunctions().httpsCallable(
    "activateMentorSession"
  );

  const activateSessionLink = () => {
    setLoading(true);
    activateSessionFunction({
      id: id,
      meetingURLCode: code,
    })
      .then(() => {
        UserNotification({
          isSuccess: true,
          message: "Meeting URL Unlocked!",
        });
        setShow(false);
      })
      .catch(() => {
        UserNotification({
          isSuccess: false,
          message: "Invalid Activation Code!",
        });
        setCodeError("Invalid activation code!");
      })
      .finally(() => {
        setLoading(false);
        setCode("");
      });
  };

  return (
    <div>
      <PageHeader title="Session" showBackButton={true} />
      <Container
        fluid
        style={{
          paddingTop: "200px",
          paddingLeft: "50px",
          paddingRight: "50px",
          paddingBottom: "50px",
          color: "#646464",
          fontSize: "18px",
        }}
      >
        <Row className="mt-4">
          <Col xs={12}>
            <h2 className="text-justify" style={{ fontWeight: 800 }}>
              {state?.title}
            </h2>
          </Col>
          <Col xs={7} className="mt-4" style={{ paddingRight: "70px" }}>
            <p className="text-justify" style={{ fontSize: "18px" }}>
              {state?.description}
            </p>
            {state?.fileURLs?.length !== 0 && (
              <div className="w-75 mt-5">
                <label>
                  <strong>Attachments:</strong>
                </label>
                <div
                  className="small-scroll pl-5 pt-3 pr-1"
                  style={{ maxHeight: "150px", overflowY: "auto" }}
                >
                  {state?.fileURLs?.map((fu, index) => {
                    return (
                      <div
                        key={index}
                        className="d-flex justify-content-between align-items-center"
                      >
                        <div>
                          <FcFile style={{ fontSize: "28px" }} />
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "bold",
                              paddingLeft: "5px",
                            }}
                          >
                            <a
                              href={fu.url}
                              rel="noopener noreferrer"
                              target="_blank"
                            >
                              {fu.fileName}
                            </a>
                          </span>{" "}
                        </div>
                        <FaEye
                          style={{ cursor: "pointer", color: "#006699" }}
                          onClick={() => {
                            window.open(fu.url);
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </Col>
          <Col xs={5} className="mt-3 px-0">
            <div className="mt-2">
              <label>
                <span className="mr-4">
                  <strong>Mentor :</strong>
                </span>{" "}
                {mentor.fullName}
              </label>
            </div>
            <div className="mt-2">
              <label>
                <span className="mr-4">
                  <strong>Start Date/Time :</strong>
                </span>
                {moment(new Date(state?.startAt?.seconds * 1000)).format(
                  "MM/DD/YYYY"
                )}
                <span className="ml-3">
                  {moment(new Date(state?.startAt?.seconds * 1000)).format(
                    "h:mm A"
                  )}
                </span>
              </label>
            </div>
            <div className="mt-2">
              <label>
                <span className="mr-4">
                  <strong>End Date/Time :</strong>
                </span>
                {moment(new Date(state?.endAt?.seconds * 1000)).format(
                  "MM/DD/YYYY"
                )}
                <span className="ml-3">
                  {moment(new Date(state?.endAt?.seconds * 1000)).format(
                    "h:mm A"
                  )}
                </span>
              </label>
            </div>
            <div className="mt-2">
              <label>
                <span className="mr-4">
                  <strong>Duration :</strong>
                </span>{" "}
                {state?.duration}
              </label>
            </div>
            <div className="mt-2">
              <label>
                <strong>Participants :</strong>
              </label>
              <div
                className="pl-5 small-scroll"
                style={{ maxHeight: "150px", overflowY: "auto" }}
              >
                {members &&
                  members.map((member, index) => {
                    return <div key={index}>{member.fullName}</div>;
                  })}
              </div>
            </div>
            {userRole.isModerator ? (
              <div className="mt-2">
                <label>
                  <strong> Link activation code :</strong>
                  <br />
                  {state.meetingURLCode}
                </label>
              </div>
            ) : (
              <div className="mt-2">
                {!state.meetingURLActivated ? (
                  <>
                    <label>
                      <strong>Session Link :</strong>
                      <br />
                      <span className="mt-3">Link is not activated </span>
                    </label>
                    <button
                      className="app-button-small ml-3"
                      style={{ borderRadius: "25px" }}
                      onClick={() => setShow(true)}
                    >
                      Active
                    </button>
                  </>
                ) : (
                  <label>
                    <strong>Session Link :</strong>
                    <br />
                    <span className="mt-3">
                      <a href={state.meetingURL}>{state.meetingURL}</a>
                    </span>
                  </label>
                )}
              </div>
            )}
          </Col>
        </Row>
      </Container>

      <Modal show={show} onHide={() => setShow(false)} centered size={"lg"}>
        <Modal.Body
          style={{
            paddingLeft: "50px",
            paddingRight: "10px",
            paddingTop: "30px",
            paddingBottom: "50px",
          }}
        >
          <Container>
            <Row>
              <Col xs={12} md={8} lg={12}>
                <Row className="buttonSet-wrapper-activation-popup">
                  <Col xs={6}>
                    <div
                      className="cancel-button-act blue-act"
                      onClick={() => {
                        setShow(false);
                      }}
                    >
                      Cancel
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={8} lg={12}>
                <p
                  style={{
                    color: "#5a5555",
                    fontWeight: "normal",
                    marginBottom: "5px",
                    fontSize: "22px",
                  }}
                >
                  Enter the code to activate session link:
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={7} style={{ paddingLeft: "0px", paddingRight: "0px" }}>
                <input
                  className="act-code-input"
                  placeholder="Activation Code"
                  value={code}
                  onChange={(e) => {
                    setCode(e.target.value);
                    setCodeError("");
                  }}
                />
                <label className="error-message">{codeError}</label>
              </Col>
              <Col xs={5}>
                {loading ? (
                  <div style={{ marginTop: "7px" }}>
                    <ClipLoader size={20} color={"#006699"} loading={true} />
                  </div>
                ) : (
                  <div
                    className="submit-button-act"
                    onClick={() => {
                      setCodeError("");
                      activateSessionLink();
                    }}
                  >
                    Submit
                  </div>
                )}
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ViewMentoringSession;
